import EventActionProto from '../event-action-proto';
import CompanyUser from "../../model2/company-user-new/company-user";
import {SessionEventData} from "../@type";
import {BUS_COMPANY_USERS_CHANGED} from "../../model2/company-user-new/@const";
import User from "../../model2/user/user";
// import CompanyUserModel from '../../gd-model/company-user/company-user';

export default class EventCompanyUsersNew_v2 extends EventActionProto {

    public header : any

    constructor(sessionEvent:SessionEventData) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)

        // this.method     = sessionEvent.method
        // this.fromSID    = sessionEvent.fromSID

        this.header     = {
            event       : sessionEvent.event,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
    }

    process() {

        // make sure user itself in session.users (!) add if not
        let sessionUser = gd.session.users.get(this.data.userId);
        if (!sessionUser) {
            gd.session.users.add(new User(this.data.user))
            // sessionUser = gd.session.users.get(this.data.userId);
        }

        const newCompanyUserModel = new CompanyUser({
            userId              : this.data.userId,
            companyId           : this.data.companyId,
            companyRole         : this.data.companyRole,
            departmentId        : this.data.departmentId,
            reportToUserId      : this.data.reportToUserId,
            workWeek            : this.data.workWeek,
            workdayDurations    : this.data.workdayDurations,

            isActivated         : this.data.isActivated,
            isDeleted           : this.data.isDeleted
        });

        if (_.get(this.data, 'isDeleted')===true) {
            gd.session.deletedCompanyUsers.add(newCompanyUserModel);
        } else {

            gd.session.companyUsers.add(newCompanyUserModel);
            gd.bus.triggerEvent(BUS_COMPANY_USERS_CHANGED)
        }

        super.process();

        this._sendBusUpdate()
    }

    _sendBusUpdate() {
        // send
        const companyUserId = this.data.companyId+"-"+this.data.userId
        gd.modelBus.newUpdate('company-user', 'new', companyUserId, this.data, this.header);
    }
};

